import React, { useEffect, useState } from 'react';
import bonus1Img from '../Assest/1.webp';
import bonus2Img from '../Assest/2.webp';
import bonus3Img from '../Assest/3.webp';
import bonus4Img from '../Assest/4.webp';
import bonus5Img from '../Assest/5.webp';
import bonus6Img from '../Assest/6.webp';

const bonusItems = [
  {
    image: bonus1Img,
    badge: 'Bonus 1',
    title: 'प्रतिज्ञा करण (AFFIRMATION) EBOOK',
    value: '999/-',
    points: [
      'वैयक्तिकृत प्रतिज्ञा (Affirmations)',
      'आरोग्य प्रतिज्ञा / Health Affirmation',
      'प्रेम आणि नाते प्रतिज्ञा / Love & Relationship Affirmation',
      'करिअर आणि पैसा प्रतिज्ञा / Career & Money Affirmations',
      'सामान्य प्रतिज्ञा / General Affirmations',
      'वैयक्तिकृत मॅनिफेस्टेशन कार्यक्रम (Personalized Manifestation Program)',
    ],
  },
  {
    image: bonus2Img,
    badge: 'Bonus 2',
    title: 'कृतज्ञता (GRATITUDE) & उपचार संगीत / HEALING MUSIC',
    value: '1,997/-',
    points: [
      '365 कृतज्ञता प्रॉम्प्ट / 365 Gratitude Prompts',
      '432 Hz उपचार संगीत / Healing Music',
      '528 Hz यश संगीत/ Success Music',
      'WhatsApp समुदायात प्रवेश/ Access to Liked Mind Community',
      'युनिक व्हिजन बोर्ड (Vision Board)',
    ],
  },
  {
    image: bonus3Img,
    badge: 'Bonus 3',
    title: 'अतिरिक्त बोनस / ADDITIONAL BONUS',
    value: '4,997/-',
    points: [
      'एक दिवसाचा Healing पास / One Day Healing Pass',
      'मॅनिफेस्टिंग झूम पार्टीमध्ये प्रवेश/ Access to Manifesting Zoom Party',
      'मॅनिफेस्टेशन मोबाइल अनुप्रयोग माहिती मिळवा (Access to Manifestation Mobile Applications)',
    ],
  },
  {
    image: bonus4Img,
    badge: 'Bonus 4',
    title: 'Routine For Your Manifestation Journey',
    value: '997/-',
    points: [
      'सकारात्मक दिनक्रम तयार करण्यासाठी मार्गदर्शन',
      'सातत्याने manifestation साधण्यासाठी practical tips',
    ],
  },
  {
    image: bonus5Img,
    badge: 'Bonus 5',
    title: 'Self Programming Challenge',
    value: '1,499/-',
    points: [
      'स्वतःच्या subconscious mind ला reprogram करण्यासाठी activities',
      'आत्मविश्वास वाढवणारे challenges',
      'आपले उद्दिष्ट पूर्ण करण्यासाठी 7-day step-by-step प्रक्रिया',
    ],
  },
  {
    image: bonus6Img,
    badge: 'Bonus 6',
    title: 'Gratitude Ebook',
    value: '497/-',
    points: [
      'जीवनात सकारात्मक बदल आणण्यासाठी gratitude चा उपयोग',
      'रोजच्या दिनचर्येत gratitude add करण्यासाठी सोप्या पद्धती',
      'आनंदी आणि समाधानी जीवनासाठी practical gratitude exercises',
    ],
  },
];

const BonusSection = () => {
  const [timeLeft, setTimeLeft] = useState(15 * 60); // 15 mins
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 1) {
          clearInterval(timer);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const minutes = String(Math.floor(timeLeft / 60)).padStart(2, '0');
  const seconds = String(timeLeft % 60).padStart(2, '0');

  const getColumns = () => {
    if (windowWidth <= 600) return 1;
    if (windowWidth <= 1024) return 2;
    if (windowWidth <= 1440) return 3;
    return 3;
  };

  return (
    <div style={styles.wrapper}>
      <h1 style={{ textAlign: 'center', color: '#333333' }}>
        Bonuses If You Register <span style={{ color: '#FF9A0B' }}>Before Timer Hits 0</span>
      </h1>

      <div style={styles.sectionInfo}>
        <p style={{ color: '#000', fontWeight: '600' }}>
          Total Value <span style={{ textDecoration: 'line-through' }}>₹10,986/-</span>
        </p>
        <p style={{ fontWeight: '600', color: '#000', marginTop: '5px' }}>
          Regular Price: <span style={{ textDecoration: 'line-through' }}>₹1,999/-</span>
        </p>
        <p style={{ color: '#000', fontWeight: '700', marginTop: '5px' }}>
          TODAY'S OFFER PRICE: <span style={{ color: '#FF9A0B' }}>₹199/-</span>
        </p>
      </div>

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: `repeat(${getColumns()}, 1fr)`,
          gap: '24px',
          maxWidth: '1000px',
          margin: '0 auto',
        }}
      >
        {bonusItems.map((item, index) => (
          <div key={index} style={styles.card}>
            <img src={item.image} alt={item.title} style={styles.image} />
            <div style={styles.badge}>
              <span style={styles.badgeIcon}>💰</span> {item.badge}
            </div>
            <h3 style={styles.title}>{item.title}</h3>
            <p style={styles.value}>Value: {item.value}</p>
            <ul style={styles.list}>
              {item.points.map((point, idx) => (
                <li key={idx} style={styles.listItem}>{point}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      {/* Countdown Timer */}
      <div style={styles.timerWrapper}>
        <h2 style={{ fontSize: '22px' }}>Register In Next 15 Mins</h2>
        <div style={styles.timerBox}>
          <div style={styles.timerItem}>
            {minutes}
            <div style={styles.timerLabel}>MINUTES</div>
          </div>
          <div style={styles.timerItem}>
            {seconds}
            <div style={styles.timerLabel}>SECONDS</div>
          </div>
        </div>
      </div>

      {/* CTA Button */}
      <div style={{ textAlign: 'center', marginTop: '10px' }}>
        <button
          style={{
            background: 'linear-gradient(49.12deg, #ffc74b 0, #e39600 22%)',
            color: 'white',
            fontSize: windowWidth <= 768 ? '18px' : '20px',
            padding: windowWidth <= 768 ? '10px 40px' : '20px 80px',
            border: 'none',
            borderRadius: '20px',
            fontWeight: 'bold',
            cursor: 'pointer',
            width: windowWidth <= 768 ? '100%' : 'auto',
          }}
        >
          Join The 2 Day Workshop for ₹199 &nbsp;
          <span style={{ textDecoration: 'line-through', opacity: 0.8 }}>₹999</span>
        </button>
        <p style={styles.ctaNote}>
          <span style={{ fontWeight: '600' }}>Registrations End on</span>{' '}
          <span style={{ fontWeight: 'bold', color: 'red' }}>11 JUL</span> <br />
          <span style={{ fontWeight: '600' }}>100%</span> मनी बॅक गॅरंटी | समाधानी नसल्यास
        </p>
      </div>
    </div>
  );
};

const styles = {
  wrapper: {
    padding: '50px 20px',
    backgroundColor: '#f7f1f1',
    fontFamily: 'Outfit, sans-serif',
  },
  sectionInfo: {
    textAlign: 'center',
    marginTop: '10px',
    marginBottom: '40px',
  },
  card: {
    backgroundColor: '#fff',
    borderRadius: '20px',
    boxShadow: '0 10px 30px rgba(0, 0, 0, 0.1)',
    paddingBottom: '20px',
    overflow: 'hidden',
    textAlign: 'center',
    maxWidth: '320px',
    margin: '0 auto',
  },
  image: {
    width: '90%',
    height: '220px',
    objectFit: 'cover',
    marginTop: '17px',
    borderRadius: '8px',
  },
  badge: {
    backgroundColor: '#0a1a48',
    color: '#ffb400',
    fontWeight: 'bold',
    padding: '10px 16px',
    borderRadius: '12px',
    margin: '20px auto 10px',
    width: 'fit-content',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)',
  },
  badgeIcon: {
    marginRight: '8px',
  },
  title: {
    fontSize: '18px',
    fontWeight: '700',
    padding: '0 16px',
    margin: '10px 0',
    lineHeight: '1.4',
  },
  value: {
    fontSize: '16px',
    fontWeight: 'bold',
    color: '#000',
    marginBottom: '10px',
  },
  list: {
    textAlign: 'left',
    padding: '0 24px',
    color: '#000',
    fontSize: '14px',
    lineHeight: '1.6',
  },
  listItem: {
    marginBottom: '8px',
    listStyleType: 'disc',
    marginLeft: '20px',
  },
  timerWrapper: {
    textAlign: 'center',
    padding: '10px 20px',
    background: '#f7f1f1',
    marginTop: '50px',
  },
  timerBox: {
    display: 'flex',
    justifyContent: 'center',
    gap: '20px',
    marginTop: '30px',
    marginBottom: '50px',
  },
  timerItem: {
    background: '#e39600',
    color: '#fff',
    padding: '15px',
    borderRadius: '8px',
    fontSize: '24px',
    fontWeight: 'bold',
    minWidth: '30px',
  },
  timerLabel: {
    fontSize: '14px',
    marginTop: '5px',
  },
  ctaNote: {
    marginTop: '10px',
    color: 'black',
    fontSize: '16px',
    fontFamily: 'outfit,sans-serif',
    fontStyle: 'italic',
  },
};

export default BonusSection;
